import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { OfferSource } from '@cds';
import { EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Group } from '@frontend/sports/grid/core/feature/model';
import { at, isEmpty } from 'lodash-es';

@Component({
    selector: 'ms-six-pack-option-group',
    templateUrl: 'six-pack-option-group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class SixpackOptionGroupComponent {
    @Input() optionGroup: EventOptionGroup;
    @Input() event: EventModel;
    @Input() group: Group;
    @Input() trackingPosition: number;
    @Input() decorateAttribute?: boolean;
    @Input() textColor?: string;
    @Input() isAutomatedMarquee: boolean;

    @HostBinding('class.six-pack-option-group') main = true;
    @HostBinding('class.six-pack-group') secondary = true;

    @HostBinding('class.offline')
    get offline(): boolean {
        return !this.optionGroup?.online || !this.optionGroup?.options?.length;
    }

    trackOption(index: number, option: EventOption): number {
        return option.id;
    }

    get options(): EventOption[] {
        if (!isEmpty(this.optionGroup.options)) {
            const optionsToShow = this.event.offerSource === OfferSource.V2 ? this.group?.optionsToShow?.v2 : this.group?.optionsToShow?.v1;

            if (!isEmpty(optionsToShow)) {
                const optionsToShowZeroBased = optionsToShow!.map((o) => --o);

                return at(this.optionGroup.options, optionsToShowZeroBased);
            }
        }

        return this.optionGroup.options;
    }

    shouldHighlight(option: EventOption): boolean {
        return this.event.fixtureForm ? this.event.isBestPerformingOption(option, this.optionGroup) : false;
    }

    getAutomationAttributes(
        option: EventOption,
        optionGroup: EventOptionGroup,
    ): {
        optionId: number;
        templateId: string;
        online: boolean;
    } {
        return {
            optionId: option.id,
            templateId: optionGroup.templateId,
            online: option.online,
        };
    }
}
